import { useState } from "react";
import Button from "../UI/Button";
import { useDispatch } from "react-redux";
import { sendManualPushNotification } from "../../redux/createMessage/slice";
import firebase from "../../firebase/config";
import { MessageState } from "../interfaces/interface";

const defaultMessageState: MessageState = {
  title: "",
  pushNotificationAndEmailDate: "",
  pushNotificationAndEmailHours: "",
  pushNotificationAndEmailMinutes: "",
  sendPushNotificationNow: false,
  descriptionForPushNotification: "",
};

export default function ManualNotification() {
  const [messages, setMessages] = useState<MessageState>(defaultMessageState);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  
  const resetForm = () => {
    setMessages(defaultMessageState);
    setSuccess("Push notification added successfully");
    setError("");
    setTimeout(() => setSuccess(""), 3000)
  };

  const getMessages = (e: any) => {
    const { name, type, value, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setMessages((prev) => ({
      ...prev,
      [name]: fieldValue,
    }));
  };

  const formatInOnlyDate = (date: any) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const saveMessage = async (e: any) => {
    e.preventDefault();
    const {
      descriptionForPushNotification,
      title,
      pushNotificationAndEmailDate,
      pushNotificationAndEmailHours,
      pushNotificationAndEmailMinutes,
      sendPushNotificationNow,
    } = e.target;

    const pushNotificationAndEmailTime = `${pushNotificationAndEmailHours.value}:${pushNotificationAndEmailMinutes.value}`;
    const pushNotificationDateAndTime = `${pushNotificationAndEmailDate.value}T${pushNotificationAndEmailTime}:00`;

    let isValid = true;
    const currentDate = new Date();
    const currentDateInMilliseconds = currentDate.setUTCHours(currentDate.getUTCHours() - 3);
    let convertedDate = new Date(pushNotificationDateAndTime).getTime() + 6 * 60 * 60 * 1000;

    const formattedCurrentDate = formatInOnlyDate(new Date(currentDate));
    const formattedConvertedDate = formatInOnlyDate(new Date(pushNotificationDateAndTime));

    if (descriptionForPushNotification.value.trim() === "") {
      setError("Please select Description for push notification correctly");
      setSuccess("");
      isValid = false;
    } else if (descriptionForPushNotification.value.trim().length >= 1000) {
      setError("Make sure that, Description has less than 1000 characters");
      setSuccess("");
      isValid = false;
    } else if (title.value.trim() === "") {
      setError("Please select title correctly");
      setSuccess("");
      isValid = false;
    } else if (pushNotificationAndEmailDate.value === "" && !sendPushNotificationNow.checked) {
      setError("Please select Push Notification Date correctly");
      setSuccess("");
      isValid = false;
    } else if (
      formattedCurrentDate === formattedConvertedDate &&
      !messages.sendPushNotificationNow
    ) {
      if (currentDateInMilliseconds <= convertedDate) {
        isValid = true;
      } else {
        setError("Please select valid time for Push Notification");
        setSuccess("");
        isValid = false;
      }
    } else if (currentDateInMilliseconds > convertedDate && !sendPushNotificationNow.checked) {
      setError("Please select valid date for Push Notification");
      setSuccess("");
      isValid = false;
    } else if (pushNotificationAndEmailTime === "" && !sendPushNotificationNow.checked) {
      setError("Please select Push Notification Time correctly");
      setSuccess("");
      isValid = false;
    }

    if (title.value.trim().length <= 5 || title.value.trim().length >= 30) {
      setError("Make sure that, title has more than 5 and less than 30 characters");
      setSuccess("");
      isValid = false;
    }

    if (isValid) {
      const messageData = {
        ...messages,
        pushNotificationAndEmailTime,
        notificationUID: crypto.randomUUID()
      };
      dispatch(sendManualPushNotification(messageData));
      resetForm();
    }
  };

  return (
    <main>
      <div className="container-fluid px-4">
        <h1>Manual Notification</h1>
        <div className="row">
          <div className="col-md-12">
            <form onSubmit={saveMessage}>
              <div className="form-row">
                Title
                <input
                  type="text"
                  className="form-control"
                  style={{ color: "black" }}
                  name="title"
                  value={messages.title || ""}
                  onChange={getMessages}
                />
              </div>

              <div className="form-row">
                Push notification will be sent on this Date
                <input
                  type="date"
                  className="form-control"
                  style={{ color: "black" }}
                  onKeyDown={(e) => e.preventDefault()}
                  name="pushNotificationAndEmailDate"
                  value={messages.pushNotificationAndEmailDate || ""}
                  onChange={getMessages}
                  disabled={messages.sendPushNotificationNow}
                />
              </div>

              <div style={{ display: "flex", alignItems: "center" }}>
                Time for Push Notification:
                <select
                  name="pushNotificationAndEmailHours"
                  onChange={getMessages}
                  value={messages.pushNotificationAndEmailHours || ""}
                  disabled={messages.sendPushNotificationNow}
                  className="form-control"
                  style={{ width: "70px", margin: "5px", color: "black" }}
                >
                  {Array.from({ length: 24 }, (_, i) => {
                    const val = i < 10 ? `0${i}` : `${i}`;
                    return (
                      <option key={i} value={val}>
                        {val}
                      </option>
                    );
                  })}
                </select>
                <span>:</span>
                <select
                  name="pushNotificationAndEmailMinutes"
                  onChange={getMessages}
                  value={messages.pushNotificationAndEmailMinutes || ""}
                  disabled={messages.sendPushNotificationNow}
                  className="form-control"
                  style={{ width: "70px", marginLeft: "5px", color: "black" }}
                >
                  {Array.from({ length: 60 }, (_, i) => {
                    const val = i < 10 ? `0${i}` : `${i}`;
                    return (
                      <option key={i} value={val}>
                        {val}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="form-row">
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="sendPushNotificationNow"
                  style={{ marginRight: "8px" }}
                  checked={messages.sendPushNotificationNow}
                  onChange={getMessages}
                />
                Send Push Notification Now
              </div>

              <div className="form-row">
                Description for Push Notification
                <textarea
                  className="form-control"
                  style={{
                    lineHeight: "normal",
                    padding: "1.5%",
                    color: "black",
                    whiteSpace: "pre-wrap",
                  }}
                  name="descriptionForPushNotification"
                  value={messages.descriptionForPushNotification || ""}
                  onChange={getMessages}
                ></textarea>
              </div>

              {error && <p style={{ color: "red" }}>{error}</p>}
              {success && <p style={{ color: "green" }}>{success}</p>}

              <Button text="Submit" className="btn btn-primary btn-lg" />
            </form>
          </div>
        </div>
      </div>
    </main>
  );
}
